import React from 'react';
import { Logout } from 'react-admin';  // Asegúrate de importar el componente Logout

import IconButton from '@mui/material/IconButton';  // Antes: 'material-ui/IconButton'
import Menu from '@mui/material/Menu';  // Antes: 'material-ui/IconMenu'
import MenuItem from '@mui/material/MenuItem';  // Antes: 'material-ui/MenuItem'
import AccountCircleIcon from '@mui/icons-material/AccountCircle';  // Antes: 'material-ui/svg-icons/action/account-circle'

const IconMenuAccount = () => {
    const [anchorEl, setAnchorEl] = React.useState(null);

    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    return (
        <div>
            <IconButton
                sx={{
                    color: "#ffffff",
                    height: "34px",
                    width: "34px"
                }}
                onClick={handleClick}
            >
                <AccountCircleIcon />
            </IconButton>
            <Menu
                anchorEl={anchorEl}
                open={Boolean(anchorEl)}
                onClose={handleClose}
                className="button-account-bar"
                anchorOrigin={{ horizontal: 'right', vertical: 'top' }}
                transformOrigin={{ horizontal: 'right', vertical: 'top' }}
            >
                <MenuItem onClick={handleClose}>
                    <Logout />
                </MenuItem>
            </Menu>
        </div>
    );
};

export default IconMenuAccount;
